import { create } from "zustand";

// Lightweight cart for the booking wizard (services + optional offer)
export const useBooking = create((set, get) => ({
  services: [],
  offer: null,
  addService: (svc) => {
    if (get().services.find((s) => s.id === svc.id)) return;
    set((st) => ({ services: [...st.services, svc] }));
  },
  removeService: (id) => set((st) => ({ services: st.services.filter((s) => s.id !== id) })),
  setOffer: (offer) => set({ offer }),
  clear: () => set({ services: [], offer: null }),
  subtotal: () => get().services.reduce((a, s) => a + Number(s.price || 0), 0),
  duration: () => get().services.reduce((a, s) => a + Number(s.duration || 0), 0),
}));
